import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Form, Select, Tag } from 'tdesign-react';
import { connect } from 'react-redux';
import { useMemoizedFn } from 'ahooks';
import { useSearchParams } from 'react-router-dom';
import { find } from 'lodash';
import OperateTitle from '@/pages/Maintenance/Executive/components/OperateTitle';
import { clusterList, getEnvList } from '@/services/resourceService';
import { clusterTypeOptions } from '@/utils/constant';
import { setCurrentCluster, setCurrentEnv } from '@/slices/execComponentSlice';
import { toTsOptions } from '@/utils/common';

const { FormItem } = Form;

function SelectCluster({ setCurrentEnv, setCurrentCluster, children }) {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const [options, setOptions] = useState([]);
  const [clusterOptions, setClusterOptions] = useState([]);

  const clusterType = Number(searchParams.get('clusterType'));

  const loadOptions = useMemoizedFn(async () => {
    const { data } = await getEnvList();
    setOptions(
      data.envInfoList.map((item) => ({
        ...item,
        id: item.envId,
        value: item.envId,
        label: item.envName,
      })),
    );
  });

  useEffect(() => {
    loadOptions();
  }, [loadOptions]);

  const envChange = async (id, { selectedOptions }) => {
    setClusterOptions([]);
    setCurrentEnv(selectedOptions[0]);
    setCurrentCluster({});
    form.reset({ fields: ['clusterId'] });
    const { data } = await clusterList({
      envId: id,
      pageSize: 99999,
      startIndex: 1,
      type: clusterType,
    });
    setClusterOptions(
      data.items.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      })),
    );
  };

  // 类型字符串
  const clusterTypeName = useMemo(() => {
    return find(clusterTypeOptions, { value: clusterType })?.label;
  }, [clusterType]);

  const clusterChange = (value, { selectedOptions }) => {
    setCurrentCluster(selectedOptions[0]);
  };

  return (
    <Root>
      <OperateTitle
        label='第一步：'
        title='选择目标集群'
        operator={<Tag>类型：{clusterTypeName}</Tag>}
      />
      <Form form={form} style={{ padding: '12px 0' }} layout='inline'>
        <FormItem name='envId' label='选择环境'>
          <Select
            options={toTsOptions(options)}
            popupProps={{ overlayInnerStyle: { width: 'auto' } }}
            onChange={envChange}
          />
        </FormItem>
        <FormItem name='clusterId' label='选择集群'>
          <Select
            options={toTsOptions(clusterOptions)}
            onChange={clusterChange}
            popupProps={{ overlayInnerStyle: { width: 'auto' } }}
          />
        </FormItem>
      </Form>
      {children}
    </Root>
  );
}

export default connect(null, {
  setCurrentEnv,
  setCurrentCluster,
})(SelectCluster);

const Root = styled.div`
  border-radius: 8px;
  border: 1px solid #e1e1e1;
  margin-bottom: 16px;
`;
